/*
 * -----------------------------------------------------------------------------
 *  Lucom Interaction Platform
 *  (C) Lucom GmbH, Erkrath. All rights reserved.
 * -----------------------------------------------------------------------------
 */

const SESSION_STORAGE_PREFIX = "lucom.ip.";

class SessionStorage {
    key;

    // id is optional
    constructor(componentName: string, id: string | undefined = undefined) {
        function buildKey(componentName: any, id: any) {
            // use common prefix to be able to clear out stuff selectively
            let shortName = componentName.replace(new RegExp("-", "g"), ".");
            if (shortName.startsWith(SESSION_STORAGE_PREFIX)) shortName = shortName.substring(SESSION_STORAGE_PREFIX.length);
            const suffix = id ? ":" + id : "";
            return SESSION_STORAGE_PREFIX + shortName + suffix;
        }

        this.key = buildKey(componentName, id);
    }

    get(parameter: string) {
        const state = JSON.parse(sessionStorage.getItem(this.key) || "{}");
        return parameter ? state[parameter] : state;
    }

    update(parameter: any, value: any) {
        const state = JSON.parse(sessionStorage.getItem(this.key) || "{}");
        if (typeof value === "undefined") delete state[parameter];
        else state[parameter] = value;
        sessionStorage.setItem(this.key, JSON.stringify(state));
    }

    remove(parameter: any) {
        this.update(parameter, undefined);
    }

    clear() {
        sessionStorage.removeItem(this.key);
    }

    static clearAll() {
        Object.keys(sessionStorage)
            .filter((key) => key.startsWith(SESSION_STORAGE_PREFIX))
            .forEach((key) => {
                sessionStorage.removeItem(key);
            });
    }
}

export default SessionStorage;
